export class PortalUser {
    admin: boolean;
    createdDate: string;
    cuid: string;
    emailAddress: string;
    expirationDate: string;
    firstName: string;
    general:  boolean;
    id: number;
    isDeployContact:  boolean;
    lastLoginDate: string;
    lastName: string;
    limited:  boolean;
    password: string;
    phoneNumber: string;
    superAdmin:  boolean;
    title: string;
    username: string;
    version: number;
}
